export enum HeroRobotVariant {
  Classic = "classic",
  Dark = "dark",
}
